var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash2 = function SvgTrash2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.667 5.828c0-.477.373-.863.833-.863h15c.46 0 .833.386.833.863 0 .476-.373.862-.833.862h-15c-.46 0-.833-.386-.833-.862",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.333 3.241a.82.82 0 0 0-.589.253.88.88 0 0 0-.244.61v.861h5v-.862a.88.88 0 0 0-.244-.61.82.82 0 0 0-.59-.252zm5.834 1.724v-.862c0-.685-.264-1.343-.733-1.828a2.46 2.46 0 0 0-1.767-.758H8.333c-.663 0-1.299.273-1.767.758a2.63 2.63 0 0 0-.733 1.828v.862H4.167c-.46 0-.834.386-.834.863v12.069c0 .685.264 1.343.733 1.828a2.46 2.46 0 0 0 1.767.758h8.334c.663 0 1.299-.273 1.767-.758a2.63 2.63 0 0 0 .733-1.829V5.829c0-.477-.373-.863-.834-.863zM5 6.69v11.206c0 .23.088.448.244.61a.82.82 0 0 0 .59.253h8.333a.82.82 0 0 0 .589-.253.88.88 0 0 0 .244-.61V6.69z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.333 9.276c.46 0 .834.386.834.862v5.172c0 .476-.373.862-.834.862s-.833-.386-.833-.862v-5.172c0-.476.373-.862.833-.862m3.334 0c.46 0 .833.386.833.862v5.172c0 .476-.373.862-.833.862s-.834-.386-.834-.862v-5.172c0-.476.373-.862.834-.862",
    clipRule: "evenodd"
  })));
};
export default SvgTrash2;